<template>
	<div class="gb-page">
		<HeadNav selectedLanguage="en" page="gb" :gotodownload="gotodownload" :apk="apk" />

		<section class="gb-hero">
			<div class="gb-hero-bg" aria-hidden="true">
				<span class="blob blob-left"></span>
				<span class="blob blob-right"></span>
				<span class="dots dots-tl"></span>
				<span class="dots dots-br"></span>
			</div>

			<div class="gb-hero-inner">
				<div class="gb-hero-copy">
					<h1>
						<span class="title-green">GB WhatsApp</span>
						<span class="title-dark">Download APK – Latest Version</span>
					</h1>

					<div class="gb-hero-tags">
						<span>
							<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 12v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7"/><path d="M12 2v10"/><path d="M8 8l4-4 4 4"/><path d="M2 12h20"/></svg>
							FREE APK
						</span>
						<span>
							<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6l7-3z"/><path d="M9.5 12l1.8 1.8L15 10"/></svg>
							v18.80
						</span>
						<span>
							<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6l7-3z"/><path d="M9.5 12l1.8 1.8L15 10"/></svg>
							Verified Safety
						</span>
					</div>

					<p class="gb-hero-lead">
						GB WhatsApp is a feature-rich WhatsApp MOD with extra privacy, customization, and messaging
						features. Download the latest GB WhatsApp APK and stay updated with new versions and guides.
					</p>

					<div class="gb-hero-actions">
						<a class="gb-btn gb-btn-primary" href="/download/">
							<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3v12"/><path d="M7 10l5 5 5-5"/><path d="M5 19h14"/></svg>
							GB WhatsApp Download
						</a>
					</div>

					<ul class="gb-hero-trust">
						<li>
							<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6l7-3z"/><path d="M9.5 12l1.8 1.8L15 10"/></svg>
							Safe Download
						</li>
						<li>
							<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6l7-3z"/><circle cx="12" cy="11" r="2"/><path d="M12 13v3"/></svg>
							Virus Checked
						</li>
						<li>
							<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M17.6 9.5c-.1-1.7 1.3-2.7 1.4-2.8-.8-1.1-2-1.3-2.4-1.3-1-.1-2 .6-2.5.6s-1.3-.6-2.2-.6c-1.1 0-2.2.7-2.8 1.7-1.2 2.1-.3 5.1.8 6.8.6.8 1.2 1.7 2.1 1.7.8 0 1.1-.5 2.1-.5s1.2.5 2.1.5 1.4-.8 1.9-1.6c.6-.9.8-1.7.8-1.8 0 0-1.6-.6-1.6-2.5zM14.9 3.9c.5-.6.8-1.4.7-2.2-.7 0-1.5.5-2 .1-.5.5-.9 1.3-.8 2.1.8.1 1.5-.4 2.1 0z"/></svg>
							Android 5+
						</li>
						<li>
							<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>
							No Root
						</li>
					</ul>
				</div>

				<div class="gb-hero-visual">
					<img
						class="gb-hero-visual-img"
						:src="visualImg"
						alt="GB WhatsApp features: privacy, themes, anti-ban, HD media, updates"
						width="833"
						height="899"
					/>
				</div>
			</div>
		</section>

		<HomeArticleEn />

		<a
			v-if="$global.isMobileDevice()"
			class="gb-btn gb-btn-primary mobile-fixed-download"
			href="/download/"
		>
			GB WhatsApp Download (v18.80)
		</a>
	</div>
</template>

<script>
import '@/css/base.scss'
import '@/css/index.scss'
import '@/css/gbappss.scss'
import HeadNav from '@/components/HeadNav.vue'
import HomeArticleEn from '@/components/HomeArticleEn.vue'

export default {
	name: 'Home',
	components: {
		HeadNav,
		HomeArticleEn,
	},
	data() {
		return {
			apk: null,
			from: 'gb',
			filename: 'gb',
			visualImg: require('@/assets/home/hero-visual-right-v2.png'),
		}
	},
	mounted() {
		this.from = this.$global.GetQueryString('from') || this.from
		this.filename = this.$global.GetQueryString('filename') || this.filename
	},
	methods: {
		gotodownload() {
			window.location.href = '/download/'
		},
	},
}
</script>

<style lang="scss" scoped>
.mobile-fixed-download {
	position: fixed;
	bottom: 12px;
	left: 50%;
	transform: translateX(-50%);
	z-index: 20;
	white-space: nowrap;
	box-shadow: 0 10px 24px rgba(34, 197, 94, 0.35);
}
</style>
